import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ApprovedFundingRequestDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveApprovedFundingRequest = createAsyncThunk<ApprovedFundingRequestDetailVM, string, { extra: Partial<Dependencies> }>(
  "fundingRequests/retrieveApprovedFundingRequest",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.getApproved(id);
  },
);

export const resetRetrieveApprovedFundingRequest = createAction("fundingRequests/resetRetrieveApprovedFundingRequest");
